import { Select, SelectProps } from 'antd'
import React from 'react'
import { useTranslation } from 'react-i18next'

type WhatsappBusinessAccountSelectProps = {
    accounts: { id: string; name: string }[]
} & SelectProps

export function WhatsappBusinessAccountSelect({ accounts, placeholder, ...props }: WhatsappBusinessAccountSelectProps) {
    const { t } = useTranslation()

    return (
        <Select
            {...props}
            placeholder={placeholder ?? t('Select WhatsApp business account')}
            options={accounts.map((account) => ({
                label: account.name,
                value: account.id,
            }))}
        />
    )
}
